// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#001529","menuText":"rgba(255,255,255,.8)","menuActiveText":"#fff"};